import React from 'react';
import Link from '@rezdy/components/Link';
import routing from '../../services/routing';
import routes from '../../constants/routes';
import { SecondaryText } from '../SignUpV2/Styled';
import { WithTranslation, withTranslation } from 'react-i18next';

const SecondaryAction = (props: WithTranslation) => {
    const i18n = { ...props };

    return (
        <SecondaryText size="small">
            <span>{i18n.t('messages.haveAccount')}</span>
            <Link href={routing.link(routes.SIGN_IN)} action="primary">
                {i18n.t('secondaryAction')}
            </Link>
        </SecondaryText>
    );
};

export default withTranslation()(SecondaryAction);
